// Fetch CSV Import Logs
export const FETCH_CSV_IMPORT_LOGS_REQUEST = 'FETCH_CSV_IMPORT_LOGS_REQUEST';
export const FETCH_CSV_IMPORT_LOGS_SUCCESS = 'FETCH_CSV_IMPORT_LOGS_SUCCESS';
export const FETCH_CSV_IMPORT_LOGS_FAILURE = 'FETCH_CSV_IMPORT_LOGS_FAILURE';

// Fetch Active CSV Import Logs
export const FETCH_ACTIVE_CSV_IMPORT_LOGS_REQUEST = 'FETCH_ACTIVE_CSV_IMPORT_LOGS_REQUEST';
export const FETCH_ACTIVE_CSV_IMPORT_LOGS_SUCCESS = 'FETCH_ACTIVE_CSV_IMPORT_LOGS_SUCCESS';
export const FETCH_ACTIVE_CSV_IMPORT_LOGS_FAILURE = 'FETCH_ACTIVE_CSV_IMPORT_LOGS_FAILURE';

// Fetch CSV Import Log by ID
export const FETCH_CSV_IMPORT_LOG_BY_ID_REQUEST = 'FETCH_CSV_IMPORT_LOG_BY_ID_REQUEST';
export const FETCH_CSV_IMPORT_LOG_BY_ID_SUCCESS = 'FETCH_CSV_IMPORT_LOG_BY_ID_SUCCESS';
export const FETCH_CSV_IMPORT_LOG_BY_ID_FAILURE = 'FETCH_CSV_IMPORT_LOG_BY_ID_FAILURE';

// Fetch CSV Import Log by Reference
export const FETCH_CSV_IMPORT_LOG_BY_REFERENCE_REQUEST = 'FETCH_CSV_IMPORT_LOG_BY_REFERENCE_REQUEST';
export const FETCH_CSV_IMPORT_LOG_BY_REFERENCE_SUCCESS = 'FETCH_CSV_IMPORT_LOG_BY_REFERENCE_SUCCESS';
export const FETCH_CSV_IMPORT_LOG_BY_REFERENCE_FAILURE = 'FETCH_CSV_IMPORT_LOG_BY_REFERENCE_FAILURE';

// Create CSV Import Log
export const CREATE_CSV_IMPORT_LOG_REQUEST = 'CREATE_CSV_IMPORT_LOG_REQUEST';
export const CREATE_CSV_IMPORT_LOG_SUCCESS = 'CREATE_CSV_IMPORT_LOG_SUCCESS';
export const CREATE_CSV_IMPORT_LOG_FAILURE = 'CREATE_CSV_IMPORT_LOG_FAILURE';

// Update CSV Import Log
export const UPDATE_CSV_IMPORT_LOG_REQUEST = 'UPDATE_CSV_IMPORT_LOG_REQUEST';
export const UPDATE_CSV_IMPORT_LOG_SUCCESS = 'UPDATE_CSV_IMPORT_LOG_SUCCESS';
export const UPDATE_CSV_IMPORT_LOG_FAILURE = 'UPDATE_CSV_IMPORT_LOG_FAILURE';

// Update CSV Import Log Confirmation
export const UPDATE_CSV_IMPORT_LOG_CONFIRMATION_REQUEST = 'UPDATE_CSV_IMPORT_LOG_CONFIRMATION_REQUEST';
export const UPDATE_CSV_IMPORT_LOG_CONFIRMATION_SUCCESS = 'UPDATE_CSV_IMPORT_LOG_CONFIRMATION_SUCCESS';
export const UPDATE_CSV_IMPORT_LOG_CONFIRMATION_FAILURE = 'UPDATE_CSV_IMPORT_LOG_CONFIRMATION_FAILURE';

// Delete CSV Import Log
export const DELETE_CSV_IMPORT_LOG_REQUEST = 'DELETE_CSV_IMPORT_LOG_REQUEST';
export const DELETE_CSV_IMPORT_LOG_SUCCESS = 'DELETE_CSV_IMPORT_LOG_SUCCESS';
export const DELETE_CSV_IMPORT_LOG_FAILURE = 'DELETE_CSV_IMPORT_LOG_FAILURE';

// Fetch CSV Import Logs Stats
export const FETCH_CSV_IMPORT_LOGS_STATS_REQUEST = 'FETCH_CSV_IMPORT_LOGS_STATS_REQUEST';
export const FETCH_CSV_IMPORT_LOGS_STATS_SUCCESS = 'FETCH_CSV_IMPORT_LOGS_STATS_SUCCESS';
export const FETCH_CSV_IMPORT_LOGS_STATS_FAILURE = 'FETCH_CSV_IMPORT_LOGS_STATS_FAILURE';

// Fetch CSV Import Logs by Date Range
export const FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_REQUEST = 'FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_REQUEST';
export const FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_SUCCESS = 'FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_SUCCESS';
export const FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_FAILURE = 'FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_FAILURE'; 